// components/gallery/PhotoViewer/index.jsx
import React, { useState, useCallback, useEffect } from "react";
import { ChevronLeft, ChevronRight, X } from "lucide-react";
import {
	ViewerOverlay,
	ViewerContainer,
	ViewerImage,
	ViewerControls,
	CloseButton,
	NavigationButton,
	PhotoDetails,
	PhotoTitle,
	PhotoCaption,
} from "./styles";

const PhotoViewer = ({ photo, photos, onClose }) => {
	const [currentIndex, setCurrentIndex] = useState(
        photos.findIndex((p) => p.id === photo.id)
    );
	const [touchStart, setTouchStart] = useState(null);
	const [touchEnd, setTouchEnd] = useState(null);

	const handlePrevious = useCallback(() => {
		setCurrentIndex((prev) => (prev > 0 ? prev - 1 : photos.length - 1));
	}, [photos.length]);

	const handleNext = useCallback(() => {
		setCurrentIndex((prev) => (prev < photos.length - 1 ? prev + 1 : 0));
	}, [photos.length]);

	// Touch handlers
	const onTouchStart = (e) => {
		setTouchEnd(null);
		setTouchStart(e.targetTouches[0].clientX);
	};

	const onTouchMove = (e) => {
		setTouchEnd(e.targetTouches[0].clientX);
	};

	const onTouchEnd = () => {
		if (!touchStart || !touchEnd) return;

		const distance = touchStart - touchEnd;
		const isLeftSwipe = distance > 50;
		const isRightSwipe = distance < -50;

		if (isLeftSwipe) {
			handleNext();
		}
		if (isRightSwipe) {
			handlePrevious();
		}
	};

	// Keyboard navigation
	useEffect(() => {
		const handleKeyDown = (e) => {
			if (e.key === "Escape") onClose();
			if (e.key === "ArrowLeft") handlePrevious();
			if (e.key === "ArrowRight") handleNext();
		};

		window.addEventListener("keydown", handleKeyDown);
		return () => window.removeEventListener("keydown", handleKeyDown);
	}, [handleNext, handlePrevious, onClose]);

	const currentPhoto = photos[currentIndex];

	return (
        <ViewerOverlay onClick={onClose}>
            <ViewerContainer 
                onClick={e => e.stopPropagation()}
                onTouchStart={onTouchStart}
                onTouchMove={onTouchMove}
                onTouchEnd={onTouchEnd}
            >
                <ViewerImage>
                    <img src={currentPhoto.imageUrl} alt={currentPhoto.title} />
                </ViewerImage>
                
                <NavigationButton 
                    className="prev" 
                    onClick={handlePrevious}
                >
                    <ChevronLeft size={24} />
                </NavigationButton>
                
                <NavigationButton 
                    className="next" 
                    onClick={handleNext}
                >
                    <ChevronRight size={24} />
                </NavigationButton>
                
                <CloseButton onClick={onClose}>
                    <X size={24} />
                </CloseButton>
            </ViewerContainer>
        </ViewerOverlay>
    );
};

export default PhotoViewer;
